export const isFullStatic = false
export const staticPath = "/app/.nuxt/static-json"
export const publicPath = "https://static.catalog.prod.coursedog.com/418daaa/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"